import { render, staticRenderFns } from "./park-call-icon.vue?vue&type=template&id=a07d4f1a"
import script from "./park-call-icon.vue?vue&type=script&lang=js"
export * from "./park-call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports